import { useSelector } from 'react-redux';
import { getSettings } from '../ducks';

export const useGetSettings = (battleId: number) => ({
  winnerSplit: useSelector(getSettings(battleId)),
});
